//MITIGATION AND PREPAREDNESS page component
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import Header from '../../components/Header'
import FullWidthImage from '../../components/FullWidthImage'
import TextBlock from '../../components/textblock'
import ContentBlock from '../../components/ContentBlock'
import ContentsTable from '../../components/ContentsTable'
import Helmet from "react-helmet"
//*******************************************************************
//******************************************************************* 
class technicalGuidesPage extends React.Component {
    
    render() {
         
        const { data } = this.props
        
        const instructionalGuide = data.instructional_guide.edges
        
        const mitigationGuide = data.mitigation_guide.edges
        
        const securityReport = data.security_report.edges

        const iGuidesTable = []
        
        const mGuidesTable = []
        
        const sReportTable = []

        for (var i = 0; i < instructionalGuide.length; i++) {
            
            iGuidesTable.push(instructionalGuide[i]);

        };
        
        for (var i = 0; i < mitigationGuide.length; i++) {
            
            mGuidesTable.push(mitigationGuide[i]);

        };
        
        for (var i = 0; i < securityReport.length; i++) {
            
            sReportTable.push(securityReport[i]);

        };
        

        const technicalGuidesPage = data.technical_guides.edges

        return (

            <div>

                
                 <Helmet>
                   <title>NJCCIC Technical Guides</title>
                    <meta name="description" content="The NJCCIC technical guides and resources for securing devices"/>
                 </Helmet>
                <Heading/>

                <Navbar/>

                {technicalGuidesPage.map(({ node: {page_title, introductory_text, image, content_group} }) => (

                    <div>

                        <PageHeader divClass="containerWidth" elementClass="pageHeader centerText" title={page_title}/>

                        <div class="container containerWidth">

                            <div class="row">

                                <TextBlock elementClass="standardText introPadding" text={introductory_text}/>

                            </div>

                        </div>
            
                        <ContentsTable testClass="testClass container containerWidth grid2Container" elementClass="col-12 col-sm-6 col-md-4 grid2 blocks block2 block2Alt" dangerousClass="standardText blockText margin btnWidth" headerStyles="header contentTitle" data={content_group} iconId="iconsGroup"/>

                        <FullWidthImage id="technicalBanner" src={image}/>  

                        {/*<ToggleNew divClass="container containerWidth" elementClass="col-12 standardText section" heading={content_title} headerStyles="header leftHeader clickableHeader pointer" subHeaderStyles="standardText leftSubHeader" data={content_group}/>*/}

                    </div>  

                ))}
                
                <div class="container-fluid">

                    <div class="container containerWidth">
                        
                        <Header styles="header contentTitle guideTitle" title="Instructional Guides" id="instructional-guides"/>
                        
                        <div class="row">
                        
                            {iGuidesTable.map(({ node }) => {

                                const postTitle = node.seo_title || node.slug

                                return (

                                    <div class="col-12 col-sm-6 offset-sm-0 col-md-4 articleFeature" key={node.slug}>
                                        
                                        <img src={node.featured_image}></img>
                                        <h3 class="header leftHeader clickableHeader postHeader articleName"><Link to={`/instructional-guides/${node.slug}`}>{postTitle}</Link></h3>
                                        <p>{node.summary}</p>
                                        <p class="fontWeight"><Link to={`/instructional-guides/${node.slug}`}>CONTINUE READING > </Link></p>

                                    </div>
                                    
                                )

                            })} 
                            
                        </div>
                        
                        <Header styles="header contentTitle guideTitle" title="Mitigation Guides" id="mitigation-guides"/>
                        
                        <div class="row">
                        
                            {mGuidesTable.map(({ node }) => {

                                const postTitle = node.seo_title || node.slug

                                return (

                                    <div class="col-12 col-sm-6 offset-sm-0 col-md-4 articleFeature" key={node.slug}>
                                        
                                        <img src={node.featured_image}></img>
                                        <h3 class="header leftHeader clickableHeader postHeader articleName"><Link to={`/mitigation-guides/${node.slug}`}>{postTitle}</Link></h3>
                                        <p>{node.summary}</p>
                                        <p class="fontWeight"><Link to={`/mitigation-guides/${node.slug}`}>CONTINUE READING > </Link></p>

                                    </div>
                                    
                                )

                            })} 
                            
                        </div>
                        
                        <Header styles="header contentTitle guideTitle" title="This is Security Series" id="security-guides"/>
                        
                        <div class="row">
                        
                            {sReportTable.map(({ node }) => {

                                const postTitle = node.seo_title || node.slug

                                return (

                                    <div class="col-12 col-sm-6 offset-sm-0 col-md-4 articleFeature" key={node.slug}>
                                        
                                        <img src={node.featured_image}></img>
                                        <h3 class="header leftHeader clickableHeader postHeader articleName"><Link to={`/this-is-security/${node.slug}`}>{postTitle}</Link></h3>
                                        <p>{node.summary}</p>
                                        <p class="fontWeight"><Link to={`/this-is-security/${node.slug}`}>CONTINUE READING > </Link></p>

                                    </div>
                                    
                                )

                            })} 
                            
                        </div>

                    </div>
                    
                </div>
                
                <Footer/>       

            </div>    

        )    
    }
    
}
//*******************************************************************
//*******************************************************************
export const query = graphql`
    query {
        instructional_guide: allButterPost(filter: {categories: {elemMatch: {name: {eq: "Instructional-Guide"}}}}) {
            edges {
                node {
                    id
                    seo_title
                    meta_description
                    slug
                    categories {
                        name
                        slug
                    }
                    tags {
                        name
                        slug
                    }
                    date
                    summary
                    author {
                        first_name
                        last_name
                        email
                        slug
                        bio
                        title
                        linkedin_url
                        facebook_url
                        instagram_url
                        pinterest_url
                        twitter_handle
                        profile_image
                    }
                    body
                    featured_image
                }
            }
        }
        mitigation_guide: allButterPost(filter: {categories: {elemMatch: {name: {eq: "Mitigation-Guide"}}}}) {
            edges {
                node {
                    id
                    seo_title
                    meta_description
                    slug
                    categories {
                        name
                        slug
                    }
                    tags {
                        name
                        slug
                    }
                    date
                    summary
                    author {
                        first_name
                        last_name
                        email
                        slug
                        bio
                        title
                        linkedin_url
                        facebook_url
                        instagram_url
                        pinterest_url
                        twitter_handle
                        profile_image
                    }
                    body
                    featured_image
                }
            }
        }
        security_report: allButterPost(filter: {categories: {elemMatch: {name: {eq: "This-Is-Security-Report"}}}}) {
            edges {
                node {
                    id
                    seo_title
                    meta_description
                    slug
                    categories {
                        name
                        slug
                    }
                    tags {
                        name
                        slug
                    }
                    date
                    summary
                    author {
                        first_name
                        last_name
                        email
                        slug
                        bio
                        title
                        linkedin_url
                        facebook_url
                        instagram_url
                        pinterest_url
                        twitter_handle
                        profile_image
                    }
                    body
                    featured_image
                }
            }
        }
        technical_guides: allButterPage(filter: { slug: { eq: "technical-guides" } }) {
            edges {
                node {
                    seo_title
                    page_title
                    introductory_text
                    image
                    image_alt_text
                    content_group {
                        section_name
                        text
                        icon
                    }
                }               
            }
        }
    }
`
export default technicalGuidesPage
//*******************************************************************
//*******************************************************************